(function () {
  'use strict';

  var header = document.querySelector('.os-header');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 40);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  var toggle = document.querySelector('.os-menu-toggle');
  var mobileNav = document.querySelector('.os-mobile-nav');
  if (toggle && mobileNav) {
    toggle.addEventListener('click', function () {
      mobileNav.classList.toggle('is-open');
    });
  }

  if ('IntersectionObserver' in window) {
    var reveals = document.querySelectorAll('.os-reveal:not(.osp .os-reveal)');
    var revealObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );
    reveals.forEach(function (el) {
      revealObserver.observe(el);
    });
  } else {
    document.querySelectorAll('.os-reveal').forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  /* ===== OVERSUN PDP (Everas structure) ===== */
  var root = document.getElementById('oversun-pdp');
  if (root) {
    var carousel = root.querySelector('[data-carousel]');
    if (carousel) {
      var track = carousel.querySelector('[data-track]');
      var slides = track ? [].slice.call(track.children) : [];
      var prevBtn = carousel.querySelector('[data-prev]');
      var nextBtn = carousel.querySelector('[data-next]');

      if (track && slides.length > 1 && prevBtn && nextBtn) {
        var slideWidth = function () {
          return slides[0].offsetWidth + parseFloat(getComputedStyle(track).gap || 0);
        };

        var syncArrows = function () {
          prevBtn.disabled = track.scrollLeft <= 0;
          nextBtn.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
        };

        track.addEventListener('scroll', syncArrows, { passive: true });
        prevBtn.addEventListener('click', function () {
          track.scrollBy({ left: -slideWidth(), behavior: 'smooth' });
        });
        nextBtn.addEventListener('click', function () {
          track.scrollBy({ left: slideWidth(), behavior: 'smooth' });
        });
        syncArrows();
      } else if (prevBtn && nextBtn) {
        prevBtn.style.display = 'none';
        nextBtn.style.display = 'none';
      }
    }

    var form = root.querySelector('form');
    var atcBtn = form && form.querySelector('.osp__atc');
    var submitLabel = form && form.querySelector('[data-submit-label]');
    var idInput = form && form.querySelector('[data-variant-id]');
    var planInput = form && form.querySelector('[data-selling-plan]');
    var selects = root.querySelectorAll('[data-variant-option]');
    var variants = window.OversunProductVariants || [];

    function renderVariant(v) {
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (atcBtn) {
        atcBtn.disabled = !v.available;
        var isSub =
          form &&
          form.querySelector('input[name="purchase_option"]:checked') &&
          form.querySelector('input[name="purchase_option"]:checked').value === 'sub';
        var challengeCta = root.dataset.challengeCta || 'Take the 60-Day Challenge';
        if (submitLabel) {
          submitLabel.textContent = v.available ? (isSub ? challengeCta : 'Add to cart') : 'Sold out';
        }
      }
    }

    if (selects.length && variants.length) {
      selects.forEach(function (sel) {
        sel.addEventListener('change', function () {
          var o = {};
          selects.forEach(function (s) {
            o[s.dataset.variantOption] = s.value;
          });
          var v =
            variants.find(function (item) {
              return item.option1 === o[1] && (!o[2] || item.option2 === o[2]);
            }) || variants[0];
          renderVariant(v);
        });
      });
    }

    var qtyInput = root.querySelector('[data-qty-input]');
    var dec = root.querySelector('[data-qty-dec]');
    var inc = root.querySelector('[data-qty-inc]');
    if (qtyInput && dec) {
      dec.addEventListener('click', function () {
        qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
      });
    }
    if (qtyInput && inc) {
      inc.addEventListener('click', function () {
        qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
      });
    }

    var dailyPriceEl = root.querySelector('[data-daily-price]');
    var dailyUnitEl = root.querySelector('[data-daily-unit]');
    var challengeSubEl = root.querySelector('[data-challenge-sub]');
    var purchaseOptions = form && form.querySelectorAll('input[name="purchase_option"]');
    var stickyPrice = document.querySelector('[data-sticky-price]');
    var stickyCta = document.querySelector('[data-sticky-cta]');

    function updatePricingDisplay(isSub) {
      if (planInput) {
        planInput.value = isSub ? root.dataset.planId || '' : '';
      }
      if (isSub) {
        if (dailyPriceEl) dailyPriceEl.textContent = root.dataset.dailySub || '';
        if (dailyUnitEl) dailyUnitEl.textContent = '/day on subscription';
        if (challengeSubEl) {
          challengeSubEl.textContent =
            'Take the challenge — if your first order is not working after 60 days, we refund you.';
        }
        if (stickyPrice && root.dataset.sub) stickyPrice.textContent = root.dataset.sub;
      } else {
        if (dailyPriceEl) dailyPriceEl.textContent = root.dataset.onetime || '';
        if (dailyUnitEl) dailyUnitEl.textContent = ' · one-time purchase';
        if (challengeSubEl) {
          challengeSubEl.textContent = 'Try a single bottle. 60-day guarantee still applies.';
        }
        if (stickyPrice && root.dataset.onetime) stickyPrice.textContent = root.dataset.onetime;
      }
      var challengeCta = root.dataset.challengeCta || 'Take the 60-Day Challenge';
      if (submitLabel && atcBtn && !atcBtn.disabled) {
        submitLabel.textContent = isSub ? challengeCta : 'Add to cart';
      }
      if (stickyCta && atcBtn && !atcBtn.disabled) {
        stickyCta.textContent = isSub ? challengeCta : 'Add to cart';
      }
    }

    if (purchaseOptions && purchaseOptions.length) {
      purchaseOptions.forEach(function (opt) {
        opt.addEventListener('change', function () {
          updatePricingDisplay(opt.value === 'sub');
        });
      });
      var checked = form.querySelector('input[name="purchase_option"]:checked');
      if (checked) updatePricingDisplay(checked.value === 'sub');
    }
  }

  /* Phases row */
  var phasesRoot = document.getElementById('oversun-phases-row');
  if (phasesRoot) {
    var row = phasesRoot.querySelector('[data-row]');
    var tiles = [].slice.call(phasesRoot.querySelectorAll('.epr__tile'));
    var dStep = phasesRoot.querySelector('[data-details-step]');
    var dSub = phasesRoot.querySelector('[data-details-sub]');
    var dBody = phasesRoot.querySelector('[data-details-body]');
    var active = tiles.findIndex(function (t) {
      return t.classList.contains('is-active');
    });
    if (active < 0) active = 0;

    function setActive(i) {
      active = Math.max(0, Math.min(i, tiles.length - 1));
      tiles.forEach(function (t, idx) {
        t.classList.toggle('is-active', idx === active);
      });
      var activeTile = tiles[active];
      if (dStep) dStep.textContent = activeTile.dataset.step || '';
      if (dSub) dSub.textContent = activeTile.dataset.sub || '';
      if (dBody) dBody.textContent = activeTile.dataset.body || '';
      if (window.matchMedia('(max-width:1023px)').matches && row) {
        row.scrollTo({ left: tiles[active].offsetLeft, behavior: 'smooth' });
      }
    }

    tiles.forEach(function (tile, idx) {
      tile.addEventListener('click', function () {
        setActive(idx);
      });
    });

    if (row) {
      var rafId = null;
      row.addEventListener(
        'scroll',
        function () {
          if (window.matchMedia('(min-width:1024px)').matches) return;
          cancelAnimationFrame(rafId);
          rafId = requestAnimationFrame(function () {
            var currentScrollLeft = row.scrollLeft;
            var best = 0;
            var minDist = Infinity;
            tiles.forEach(function (t, idx) {
              var dist = Math.abs(t.offsetLeft - currentScrollLeft);
              if (dist < minDist) {
                minDist = dist;
                best = idx;
              }
            });
            if (best !== active) setActive(best);
          });
        },
        { passive: true }
      );
    }

    window.oversunPhases = { setActive: setActive };
  }

  /* 60-day CTA scroll to buy */
  document.querySelectorAll('.osp60d__cta').forEach(function (cta) {
    cta.addEventListener('click', function (e) {
      var buy = document.getElementById('buy');
      if (!buy) return;
      e.preventDefault();
      buy.scrollIntoView({ behavior: 'smooth', block: 'start' });
      var subRadio = buy.querySelector('input[name="purchase_option"][value="sub"]');
      if (subRadio) {
        subRadio.checked = true;
        subRadio.dispatchEvent(new Event('change', { bubbles: true }));
      }
      var box = buy.querySelector('.ospPlan__box');
      if (box) {
        setTimeout(function () {
          try {
            box.focus();
          } catch (err) {}
        }, 400);
      }
    });
  });

  /* Sticky bar */
  var buyBox = document.getElementById('buy');
  var stickyBar = document.querySelector('[data-sticky-bar]');
  if (buyBox && stickyBar && 'IntersectionObserver' in window) {
    var stickyObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          stickyBar.hidden = entry.isIntersecting;
        });
      },
      { threshold: 0, rootMargin: '0px 0px -80px 0px' }
    );
    stickyObserver.observe(buyBox);
  }
})();
